import { PanelItem } from '../panel-item.class';

export const getPreviousItemCfn = (panelItem: PanelItem, includePlacements: Array<string> = []): PanelItem | null => {
	const { panelItemGroup } = panelItem.refMap;
	if (panelItemGroup === null) return null;

	const items = panelItemGroup.items.filterItems(false, includePlacements)
		.filter((i) => i.center.y < panelItem.center.y)
		.sort((a, b) => { return b.center.y - a.center.y });

	return items.length > 0 ? items[0] as PanelItem : null;
};
